module.exports = __webpack_public_path__ + "static/media/plus-button-white.9d94b29a.svg";